export default {
  getHead: () => {
    return [{name: '사업장명'}, {name: '작업내용'}, {name: '재해형태'}, {name: '발생일시'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.field_name // 사업장명
        case 1: return func.getContent(value).inputB_1 // 작업내용
        case 2: return func.getContent(value).inputB_3 // 재해형태
        case 3: return func.getContent(value).inputB_4 // 발생일시
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { disasterType: nav.value.disasterType, searchType: nav.value.searchType,  searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    if (nav.value.disasterType) returnData.push('content$body.inputB_3*[:default_disaster]')

    switch (nav.value.searchType) {
      case '사업장명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
      case '작업내용': returnData.push('content$body.inputB_1*%[:default_skw]%'); break
      case '발생일시': returnData.push('content$body.inputB_4*%[:default_skw]%'); break
    }

    return returnData
  },
}
